var exports = {
  "B8": "List__56CF9F",
  "fI": "Row__a-mw4J",
  "UC": "Content__mKYS1U",
  "N_": "Link__pyuf0b",
  "r9": "InstallMetadata__DfGpRC",
  "ut": "SkillInstallMenu__n6Et5Q",
  "Pp": "InstallPanelSection__8wRqKf",
  "f6": "InstallPanelDivider__B5pw5M",
  "V8": "SkillInstallHeading__B6BtN0",
  "oX": "SkillInstallOption__meu3wV",
  "S3": "CLIInstallOptions__G5Ntdi",
  "Sm": "PluginMarketplaceSteps__JVjiwl",
  "nu": "PluginMarketplaceStep__6vGy9X",
  "et": "SkillInstallOptionHeading__WQe7DH",
  "f9": "SkillInstallDescription__djbmW_",
  "Oz": "SkillInstallCommand__u6SrmY",
  "Sk": "SkillInstallCopyButton__TFvVSG",
  "uW": "SkillInstallCode__4PwJz8",
  "ls": "SkillInstallMultilineCode__6_OeF_",
  "OS": "Metadata__eJRdLA",
  "vt": "ResourceType__ZCDgLl",
  "wv": "Separator__sE_ljz",
};

module.exports = exports;
